import { toast } from "react-toastify";

import { REGEX } from "@/constants/regex";

import api from "../api";

//TODO Aparentemente mesmo o renavan não sendo compatível com a placa ele ainda processa o cadastro, relatar ao Rafael
async function patchTruckRebind<T extends NextApp.TruckRebindBody>(body: T, options?: NextApp.ServiceOptions) {
  options?.onInit?.();

  try {
    await api.patch("truck/rebind", body);
    sessionStorage.removeItem("@App:driverId");
    toast.success("Cadastro realizado com sucesso!");
    options?.onSuccess?.(body);

    return [false, true, body] as const;
  } catch (e: any) {
    if (e.response?.data?.response?.driver?.id) {
      sessionStorage.setItem("@App:driverId", e.response?.data?.response?.driver?.id);
    }

    if (e.response?.data?.code === "ER_DUP_ENTRY") {
      toast.error("Já existe cadastro!");
    } else {
      toast.error(`Erro ao Cadastrar: ${e.response?.data?.message || "Tente novamente mais tarde."}`);
    }

    options?.onError?.({ code: e.response?.data?.code, message: e.response?.data?.message });

    return [true, false, body] as const;
  } finally {
    console.log("patchTruckRebind executed with body:", body);
    options?.onFinally?.();
  }
}

type EditTruckBody = {
  id: number;
  company: {
    id: number;
  };
  driver: {
    id: number;
  };
  vehicleModel: {
    id: number;
  };
  licensePlate: string;
  renavam: string;
  owner: string;
  implementType: string;
  shaftQuantity: number;
  grossCapacity: number;
  netCapacity: number;
  color: string;
};
async function editTruck(body: EditTruckBody) {
  try {
    await api.post("truck/app/edit", body);
    toast.success("Caminhão editado com sucesso!");
    return { body, success: true, error: false };
  } catch (_error) {
    toast.error("Erro ao editar o caminhão. Tente novamente mais tarde.");
    return { success: false, error: true } as const;
  } finally {
    console.log("editTruck executed");
  }
}

async function deleteTruck(
  id: number,
  options?: { onInit?: () => void; onError?: () => void; onSuccess?: (data: { success: boolean; error: boolean }) => void; onFinally?: () => void }
) {
  if (!id) {
    toast.error("ID inválido. Tente novamente.");
    return { success: false, error: true } as const;
  }

  const onlyNumbers = REGEX.PRIMITIVES.ONLY_NUMBERS;
  if (!onlyNumbers.test(String(id))) {
    toast.error("ID inválido. Tente novamente.");
    return { success: false, error: true } as const;
  }

  options?.onInit?.();
  try {
    await api.patch(`truck/unbind`, {
      truck: {
        id
      }
    });
    const data = { success: true, error: false };
    toast.success("Caminhão deletado com sucesso!");

    options?.onSuccess?.(data);
    return data;
  } catch (_error) {
    console.log(_error);
    toast.error("Erro ao deletar o caminhão. Tente novamente mais tarde.");

    options?.onError?.();
    return { success: false, error: true } as const;
  } finally {
    options?.onFinally?.();
    console.log("deleteTruck executed");
  }
}

export const truckMutations = {
  patchTruckRebind,
  editTruck,
  deleteTruck
};
